/* Tend Women's — Founding Offer lander: behavior.
   · Gallery: thumbnails + arrows switch slides (wraps). Main image height is
     measured so the thumbnail row ends level with the Benefits card.
   · Calcium chips: click sets the active ingredient; description + image swap.
   · FAQ: single-open accordion; click the open item to close it.
   · Checkout: clear cart → add Founding variant with the Founding selling
     plan → /checkout. Falls back to the plain form POST on any failure.
   · Closed state: re-checked on load from the deadline in the section config.
   Markup + settings: sections/tw-founding.liquid · Styles: assets/tw-founding.css */
(function () {
  'use strict';

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  // ── Gallery ──────────────────────────────────────────────────────────
  function initGallery(root) {
    var gal = qs(root, '[data-twf-gallery]');
    if (!gal) return;
    var slides = qsa(gal, '[data-twf-slide]');
    var thumbs = qsa(gal, '[data-twf-thumb]');
    if (!slides.length) return;
    var current = 0;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === current); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === current);
        t.setAttribute('aria-selected', k === current ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = qs(gal, '[data-twf-prev]'), next = qs(gal, '[data-twf-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    // Height: benefitsCard.bottom − grid.top − thumbRow.height − 12px (desktop only)
    var grid = qs(root, '[data-twf-grid]');
    var main = qs(gal, '[data-twf-galmain]');
    var thumbRow = qs(gal, '[data-twf-thumbs]');
    var bench = qs(root, '[data-twf-benefits]');
    var last = 0;
    function measure() {
      if (!grid || !main || !thumbRow || !bench) return;
      if (window.innerWidth < 760 || getComputedStyle(gal).display === 'none') { main.style.height = ''; return; }
      var h = Math.round(bench.getBoundingClientRect().bottom - grid.getBoundingClientRect().top - thumbRow.offsetHeight - 12);
      if (h > 200 && Math.abs(h - last) > 1) { last = h; main.style.height = h + 'px'; }
    }
    window.addEventListener('resize', measure);
    if ('ResizeObserver' in window) { new ResizeObserver(measure).observe(grid); }
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(measure); }
    setTimeout(measure, 50);
    setTimeout(measure, 600);
  }

  // ── Calcium chips ────────────────────────────────────────────────────
  function initCalcium(root) {
    var box = qs(root, '[data-twf-calcium]');
    if (!box) return;
    var chips = qsa(box, '[data-twf-chip]');
    var panels = qsa(box, '[data-twf-chip-panel]');
    var imgs = qsa(box, '[data-twf-chip-img]');
    chips.forEach(function (chip, i) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c, k) { c.classList.toggle('is-active', k === i); c.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        panels.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
        imgs.forEach(function (m, k) { m.classList.toggle('is-active', k === i); });
      });
    });
  }

  // ── FAQ ──────────────────────────────────────────────────────────────
  function initFaq(root) {
    var faq = qs(root, '[data-twf-faq]');
    if (!faq) return;
    var items = qsa(faq, '[data-twf-faq-item]');
    items.forEach(function (item) {
      var btn = qs(item, '[data-twf-faq-toggle]');
      var panel = qs(item, '[data-twf-faq-panel]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        items.forEach(function (o) {
          o.classList.remove('is-open');
          var b = qs(o, '[data-twf-faq-toggle]'), p = qs(o, '[data-twf-faq-panel]');
          if (b) b.setAttribute('aria-expanded', 'false');
          if (p) p.hidden = true;
        });
        if (!open) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); panel.hidden = false; }
      });
    });
  }

  // ── Closed state (deadline) ──────────────────────────────────────────
  function initDeadline(root, cfg) {
    if (!cfg || cfg.closedMode !== 'auto' || !cfg.deadline) return;
    var d = Date.parse(cfg.deadline);
    if (isNaN(d)) return;
    function check() { if (Date.now() > d) document.documentElement.setAttribute('data-twf-expired', ''); }
    check();
    setInterval(check, 60 * 1000);
  }

  // ── Checkout ─────────────────────────────────────────────────────────
  function readConfig(form) {
    try { return JSON.parse(form.getAttribute('data-twf-config') || '{}'); } catch (e) { return {}; }
  }

  function utmAttributes() {
    var out = {}, any = false;
    try {
      var p = new URLSearchParams(window.location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'aud'].forEach(function (k) {
        var v = p.get(k); if (v) { out[k] = String(v).slice(0, 100); any = true; }
      });
    } catch (e) { /* ignore */ }
    out.landing = 'womens-founding';
    return out;
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body || {})
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var err = new Error(j.description || j.message || ('HTTP ' + r.status)); err.payload = j; throw err; }
        return j;
      });
    });
  }

  function initCheckout(root) {
    var form = qs(root, '[data-twf-buy]');
    if (!form) return;
    var cfg = readConfig(form);
    initDeadline(root, cfg);
    var ctas = qsa(root, '[data-twf-cta]');
    var errBox = qs(root, '[data-twf-cta-error]');
    var busy = false;

    function setBusy(on) {
      busy = on;
      ctas.forEach(function (b) {
        b.classList.toggle('is-busy', on);
        b.disabled = on;
        var label = qs(b, '[data-twf-cta-label]');
        if (label) {
          if (on) { label.setAttribute('data-twf-idle', label.textContent); label.textContent = cfg.busyLabel || 'One moment…'; }
          else if (label.getAttribute('data-twf-idle')) { label.textContent = label.getAttribute('data-twf-idle'); }
        }
      });
    }
    function showError(msg) {
      if (!errBox) return;
      errBox.textContent = msg || cfg.errorLabel || errBox.textContent;
      errBox.hidden = false;
    }

    form.addEventListener('submit', function (ev) {
      if (busy) { ev.preventDefault(); return; }
      if (!window.fetch || !cfg.variantId) return; // plain POST → /cart/add → /checkout
      ev.preventDefault();
      if (errBox) errBox.hidden = true;
      setBusy(true);

      var item = { id: Number(cfg.variantId), quantity: 1 };
      if (cfg.sellingPlanId) item.selling_plan = Number(cfg.sellingPlanId);
      if (cfg.propertyKey && cfg.propertyValue) { item.properties = {}; item.properties[cfg.propertyKey] = cfg.propertyValue; }

      var start = cfg.clearCart ? postJSON('/cart/clear.js') : Promise.resolve();
      start
        .then(function () { return postJSON('/cart/add.js', { items: [item] }); })
        .then(function () { return postJSON('/cart/update.js', { attributes: utmAttributes() }).catch(function () { /* attribution is best-effort */ }); })
        .then(function () { window.location.assign(cfg.checkoutUrl || '/checkout'); })
        .catch(function (err) {
          // Shopify answers 422 when the product is unavailable (draft /
          // sold out). Show the message; anything else falls back to the
          // plain form so the customer still reaches checkout.
          setBusy(false);
          var msg = err && err.message ? err.message : '';
          if (err && err.payload && (err.payload.status === 422 || /sold out|unavailable|not found/i.test(msg))) {
            showError(cfg.errorLabel ? cfg.errorLabel + ' (' + msg + ')' : msg);
            return;
          }
          try { HTMLFormElement.prototype.submit.call(form); } catch (e) { showError(); }
        });
    });
  }

  // ── Boot (also on theme-editor section reloads) ──────────────────────
  function init(scope) {
    qsa(scope || document, '[data-twf]').forEach(function (root) {
      if (root.getAttribute('data-twf-ready')) return;
      root.setAttribute('data-twf-ready', '1');
      initGallery(root);
      initCalcium(root);
      initFaq(root);
      initCheckout(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
